module.exports = __webpack_public_path__ + "img/smartcredit.37b069c7.svg";